import React from 'react';
import {Field, FieldDescription, FieldError, FieldLabel} from "@root/server/client/esweb/components/ui/field";
import {Control, Controller, FieldPath} from "react-hook-form";
import {Select, SelectContent, SelectItem, SelectTrigger, SelectValue} from "@root/server/client/esweb/components/ui/select";
import {cn} from "@root/server/client/esweb/lib/utils.ts";
import {NativeSelect, NativeSelectOption} from "../native-select";

let ix = 0;

type SelectOptionType = {
    label: string,
    value: unknown
}

export function RhfSelect<FORM_TYPE>(params: {
    name: FieldPath<FORM_TYPE>
    label?: string,
    control: Control<FORM_TYPE>,
    options: SelectOptionType[],
    placeholder?: string,
    className?: string,
}) {
    const id = `rfhselect-${ix++}`;

    const {
        name,
        label,
        control,
        options,
        placeholder,
        className
    } = params;

    return <Controller
        {...{name, control}}

        render={({ field, fieldState }) => (
            <Field data-invalid={fieldState.invalid} {...{className}}>
                {label && <FieldLabel htmlFor={id}>{label}</FieldLabel>}
                <Select
                    name={field.name}

                    /* null to undefined for select to represent it as empty state and show placeholder */
                    value={JSON.stringify(field.value ?? undefined)}

                    /* undefined back to null */
                    onValueChange={(val) => field.onChange(JSON.parse(val ?? 'null'))}
                >
                    <SelectTrigger
                        id={id}
                        aria-invalid={fieldState.invalid}
                        className="bg-white"
                    >
                        <SelectValue {...{placeholder}}/>
                    </SelectTrigger>
                    <SelectContent>
                        {options.map(o =>
                            <SelectItem value={JSON.stringify(o.value)}>{o.label}</SelectItem>
                        )}
                    </SelectContent>
                </Select>
                {/*<FieldDescription>*/}
                {/*    Choose how often you want to be billed.*/}
                {/*</FieldDescription>*/}
                {fieldState.invalid && (
                    <FieldError errors={[fieldState.error]} />
                )}
            </Field>
        )}
    />
}

export function RhfNativeSelect<FORM_TYPE>(params: {
    name: FieldPath<FORM_TYPE>
    label?: string,
    control: Control<FORM_TYPE>,
    options: SelectOptionType[],
    placeholder?: string,
    className?: string,
}) {
    const id = `rfhselect-${ix++}`;

    const {
        name,
        label,
        control,
        options,
        placeholder,
        className
    } = params;

    return <Controller
        {...{name, control}}

        render={({ field, fieldState }) => (
            <Field data-invalid={fieldState.invalid} {...{className}}>
                {label && <FieldLabel htmlFor={id}>{label}</FieldLabel>}
                <NativeSelect
                    aria-invalid={fieldState.invalid}
                    name={field.name}
                    className={cn(
                        (field.value != null) ? null : 'text-gray-500', //inteionally not !== to match undefined
                        className,
                    )}
                    /* null to undefined for select to represent it as empty state and show placeholder */
                    value={JSON.stringify(field.value ?? undefined)}
                    /* undefined back to null */
                    onChange={(val) => field.onChange(JSON.parse(val.target.value ?? 'null'))}
                >
                    <NativeSelectOption value="" disabled selected hidden className="text-slate-500">{placeholder}</NativeSelectOption>
                    {options.map(o =>
                            <NativeSelectOption selected={JSON.stringify(o.value) === field.value} value={JSON.stringify(o.value)}>{o.label}</NativeSelectOption>
                        )}
                </NativeSelect>
                {/*<FieldDescription>*/}
                {/*    Choose how often you want to be billed.*/}
                {/*</FieldDescription>*/}
                {fieldState.invalid && (
                    <FieldError errors={[fieldState.error]} />
                )}
            </Field>
        )}
    />
}